import { Link } from "react-router-dom";
import { scrollToId } from "../hooks/useLenis";

export const Footer = () => (
  <footer data-testid="main-footer" className="border-t border-line bg-void py-12">
    <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 px-5 md:flex-row">
      <button
        data-testid="footer-logo"
        onClick={() => scrollToId("#top")}
        className="font-display text-lg font-extrabold tracking-widest text-slate-100"
      >
        IMMERSION<span className="text-cyan-400">+</span>
      </button>
      <nav className="flex flex-wrap items-center justify-center gap-6">
        {["#experiences", "#equipements", "#tarifs", "#infos"].map((href) => (
          <button
            key={href}
            data-testid={`footer-link-${href.slice(1)}`}
            onClick={() => scrollToId(href)}
            className="font-hud text-[11px] uppercase tracking-[0.2em] text-slate-500 transition-colors hover:text-cyan-400"
          >
            {href.slice(1)}
          </button>
        ))}
        <Link
          data-testid="footer-admin-link"
          to="/admin"
          className="font-hud text-[11px] uppercase tracking-[0.2em] text-fuchsia-500/80 transition-colors hover:text-fuchsia-400"
        >
          Accès staff
        </Link>
      </nav>
      <p className="font-hud text-[10px] uppercase tracking-[0.2em] text-slate-600">
        © 2026 Immersion Plus — Mareuil-lès-Meaux · Musique : Kevin MacLeod (incompetech.com, CC-BY 3.0)
      </p>
    </div>
  </footer>
);
